import { render, staticRenderFns } from "./StoryTab.vue?vue&type=template&id=11689c40"
import script from "./StoryTab.vue?vue&type=script&lang=js"
export * from "./StoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11689c40')) {
      api.createRecord('11689c40', component.options)
    } else {
      api.reload('11689c40', component.options)
    }
    module.hot.accept("./StoryTab.vue?vue&type=template&id=11689c40", function () {
      api.rerender('11689c40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/StoryTab.vue"
export default component.exports